import * as React from 'react';
import MaterialFilesUploadView from '../layouts/MaterialFilesUploadView';
import { MaterialFilesData } from 'src/reducers/materialFiles';

export interface MaterialFilesUploadViewProps {
    onComponentDidMount: () => void;
    materialFilesData: MaterialFilesData[];
    materialprogress: number;
    materialfiles: string;
    saveMaterialfiles: (customermaterialfiles: File) => void;
    onSubmit: () => void;
    onClear: () => void;
}

class MaterialFilesUploadPage extends React.Component<MaterialFilesUploadViewProps> {
    render() {
        return (
            <div>
                <MaterialFilesUploadView
                    materialFilesData={this.props.materialFilesData}
                    saveMaterialfiles={this.props.saveMaterialfiles}
                    onSubmit={this.props.onSubmit}
                    onClear={this.props.onClear}
                    materialprogress={this.props.materialprogress}
                    materialfiles={this.props.materialfiles}
                />
            </div>
        );
    }
    componentDidMount() {
        this.props.onComponentDidMount();
    }
}

export default MaterialFilesUploadPage;



// WEBPACK FOOTER //
// ./src/components/MaterialFilesUpload/MaterialFilesUploadPage.tsx